import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useNavigate } from "react-router-dom";
import { Button, Skeleton, Stack, Typography } from "@mui/material";
import CloudIcon from "@mui/icons-material/Cloud";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import { Box } from "@mui/system";

import { LoadingButton } from "@mui/lab";

const rows = [1, 2, 3, 4, 5, 6, 7, 8];

export default function TableUsers(props) {
  const { loadingButton, handleStatus, users, isUserPage, loading } = props;
  const navigate = useNavigate();
  const navigateTo = (goTo) => {
    navigate(goTo);
  };

  if (isUserPage) {
    return (
      <Box sx={{ overflow: "auto" }}>
        <Table stickyHeader size="medium">
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography color="primary">Nome</Typography>
              </TableCell>
              <TableCell align="center">
                <Typography color="primary">CPF/CNPJ</Typography>
              </TableCell>
              <TableCell align="center">
                <Typography color="primary">Tipo de Usuário</Typography>
              </TableCell>
              <TableCell align="right">
                <Typography color="primary">Opções</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <>
                {rows.map((id) => (
                  <TableRow key={id}>
                    <TableCell>
                      <Skeleton width={100} variant="rectangular" />
                    </TableCell>
                    <TableCell align="center">
                      <Skeleton width={"100%"} variant="rectangular" />
                    </TableCell>
                    <TableCell align="center">
                      <Skeleton width={"100%"} variant="rectangular" />
                    </TableCell>
                    <TableCell align="right">
                      <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={2}
                      >
                        <Skeleton
                          sx={{ mr: 2 }}
                          width={100}
                          height={35}
                          variant="rectangular"
                        />
                        <Skeleton
                          width={100}
                          height={35}
                          variant="rectangular"
                        />
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : (
              users
                .map((user) => (
                  <TableRow key={user.id}>
                    <TableCell>{user.name}</TableCell>
                    <TableCell align="center">{user.cpf_cnpj}</TableCell>
                    <TableCell align="center">
                      {" "}
                      {user.type === "client"
                        ? "Cliente"
                        : user.type === "support"
                        ? "Funcionário"
                        : "Admin"}
                    </TableCell>

                    <TableCell align="right">
                      <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={2}
                      >
                        <LoadingButton
                          loading={
                            loadingButton.loading &&
                            user.id === loadingButton.id
                          }
                          onClick={() => handleStatus(user.id, user.status)}
                          endIcon={
                            user.status === "active" ? (
                              <CloudDoneIcon />
                            ) : user.status === "inactive" ? (
                              <CloudOffIcon />
                            ) : (
                              <CloudDoneIcon />
                            )
                          }
                          variant={
                            user.status === "active"
                              ? "contained"
                              : user.status === "inactive"
                              ? "outlined"
                              : "contained"
                          }
                        >
                          {user.status === "active"
                            ? "Ativo"
                            : user.status === "inactive"
                            ? "Inativo"
                            : "Ativo"}
                        </LoadingButton>
                        <Button
                          sx={{ ml: 2 }}
                          onClick={() => navigateTo(`/users/${user.id}`)}
                          endIcon={<CloudIcon />}
                          variant="contained"
                        >
                          Dados
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))

                .reverse()
            )}
          </TableBody>
        </Table>
      </Box>
    );
  }

  return (
    <Box sx={{ overflow: "auto", textAlign: "center" }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell align="center">CNPJ</TableCell>
            <TableCell align="center">Tipo de Usuário</TableCell>
            <TableCell align="right">Status da Conta</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users
            .map(
              (user) =>
                !(user.type === "admin") && (
                  <TableRow key={user.id}>
                    <TableCell>{user.name}</TableCell>
                    <TableCell align="center">{user.cpf_cnpj}</TableCell>
                    <TableCell align="center">
                      {user.type === "client" ? "Cliente" : "Funcionário"}
                    </TableCell>
                    <TableCell align="right">
                      {user.status === "active"
                        ? "Ativa"
                        : user.status === "inactive"
                        ? "Inativa"
                        : "Ativa"}
                    </TableCell>
                  </TableRow>
                )
            )
            .reverse()}
        </TableBody>
      </Table>
      <Button
        color="primary"
        onClick={() => navigateTo("/clients")}
        sx={{ mt: 3 }}
      >
        Veja todos Usuários
      </Button>
    </Box>
  );
}
